export const CONTACT_FORM_STEP = "ContactForm";
export const MESSAGE_SCREENING_STEP = "MessageScreening";
export const POST_SUBMIT_QUESTIONNAIRE_STEP = "PostSubmitQuestionnaire";
export const CONFIRMATION_MODAL_STEP = "ConfirmationModal";
